module.exports = __webpack_public_path__ + "img/logo.eac13b83.png";